export interface BrowserRandomSource {
  readonly randomUUID?: () => string;
  readonly getRandomValues?: (values: Uint8Array<ArrayBuffer>) => Uint8Array<ArrayBuffer>;
}

const RANDOM_UNAVAILABLE_MESSAGE = '当前浏览器不支持安全随机数，请升级浏览器后重试。';

export function secureRandomUuid(
  source: BrowserRandomSource | null | undefined = globalThis.crypto,
): string {
  if (typeof source?.randomUUID === 'function') {
    try {
      return source.randomUUID.call(source);
    } catch {
      // Some browsers expose randomUUID but reject it outside a secure context.
    }
  }

  if (typeof source?.getRandomValues !== 'function') {
    throw new Error(RANDOM_UNAVAILABLE_MESSAGE);
  }

  const bytes = source.getRandomValues.call(source, new Uint8Array(16));
  if (!(bytes instanceof Uint8Array) || bytes.length !== 16) {
    throw new Error(RANDOM_UNAVAILABLE_MESSAGE);
  }
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;

  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex
    .slice(6, 8)
    .join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
}
